import { jitsiLocalStorage } from '@jitsi/js-utils';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
// import { v4 as uuidv4 } from 'uuid';
// import Randomstring from "randomstring";
import moment from 'moment-timezone';
import { meetService, callService2 } from '../../../../../service';
import { STATUS } from '../../../../../socket/config';
import { SocketContext } from '../../../../../socket/socket.context';
import { goToRoomWithToken } from '../../../../../utils';

interface MenuButtonsProps {
    onChange?: (value?: string) => void;
    value?: string;
    isRoom?: boolean;
    isHideMenu: boolean;
    openPopUp: () => void;
    popUpName: (name: string) => void;
    isOpen: boolean;
    onToggleDisturb: () => void;
    isNotDisturb: boolean;
    closeSchedCall: () => void;
    closeRecentCall: () => void;
    closeCreateGroup: () => void;
}

const listMenu = [
    {
        icon: '../../../../../images/button-icon/recent-call.svg',
        name: 'recent-call'
    },
    {
        icon: '../../../../../images/button-icon/contact.svg',
        name: 'contact'
    },
    {
        icon: '../../../../../images/button-icon/numbers.svg',
        name: 'numbers'
    },
    {
        icon: '../../../../../images/button-icon/share.svg',
        name: 'share'
    },
    {
        icon: '../../../../../images/button-icon/dnd.svg',
        name: 'disturb'
    },
    {
        icon: '../../../../../images/button-icon/setting.svg',
        name: 'setting'
    }
];

export const MenuButtons: React.FC<MenuButtonsProps> = props => {
    const {
        onChange = () => { },
        value,
        isRoom = false,
        isHideMenu,
        closeRecentCall = () => { },
        closeCreateGroup = () => { }
    } = props;
    const { sendUserStatus } = useContext(SocketContext);
    const { user } = useSelector(state => state['features/settings']);
    const [menuActive, setMenuActive] = useState('');
    const _jwt = useSelector(state => state['features/base/jwt']);

    const handleOpenPopup = name => {
        if (menuActive === 'disturb' && name !== 'disturb') {
            return;
        }
        if (name === menuActive) {
            setMenuActive('');
            onChange('');
        } else {
            setMenuActive(name);
            onChange(name);
        }
        if (name === 'disturb') {
            const dnd = menuActive === 'disturb';

            jitsiLocalStorage.setItem('isKeepDnd', !dnd);
            sendUserStatus(user.id, dnd ? STATUS.ONLINE : STATUS.DND);
        }
        closeRecentCall();
        closeCreateGroup();
    };

    useEffect(() => {
        if (value !== menuActive) {
            setMenuActive(value);
        }
    }, [value]);

    const size = useMemo(
        () => window.innerHeight / 5 / 2,
        [window.innerHeight]
    );

    useEffect(() => {
        if (isHideMenu) {
            setMenuActive('');
            onChange('');
        }
    }, [isHideMenu]);

    const onStartConference = async () => {
        const timeZone = moment.tz.guess();

        await callService2.createUserCall(user.id, false, timeZone)
                .then(async res => {
                    const meeting = await meetService.createMeeting(res?.data?.callingHistory?.id, `${user.firstName} ${user.lastName}`, user.email, user.id);

                    const meetingrest = await meetService.getMeetingData(meeting?.data?.id);


                    sendUserStatus(user.id, STATUS.BUSY);
                    goToRoomWithToken(meetingrest.authRoom, meetingrest.token);
                });

    };

    return (
        <div>
            <div className={'m-menu-buttons'}>
                <div
                    className='start-call'
                    onClick={onStartConference}>
                    {'START A\nCONFERENCE'}
                </div>
                {listMenu.map(item => {
                    let className = `m-menu-button ${menuActive === item.name ? 'm-menu-button--red' : ''
                        } `;

                    let disabled = false;

                    if (item.name !== 'disturb' && menuActive === 'disturb') {
                        disabled = true;
                    }

                    if (isRoom && item.name === 'disturb') {
                        disabled = true;
                    }

                    if (disabled) {
                        className += ' m-menu-button--disabled';
                    }
                    if (_jwt && _jwt?.user && _jwt?.user?.id === 'guest-id') {
                        if (
                            item.name === 'recent-call'
                            || item.name === 'contact'
                            || item.name === 'numbers'
                            || item.name === 'setting'
                        ) {
                            disabled = true;
                        }
                    }

                    return (
                        <div
                            className={className}
                            key={item.name}
                            onClick={
                                !disabled
                                    ? () => handleOpenPopup(item.name)
                                    : undefined
                            }>
                            <img
                                alt=''
                                height={size}
                                src={item.icon} />
                        </div>
                    );
                })}
            </div>
            <div
                className='start-call-mobile'
                onClick={onStartConference}>
                {'START A CONFERENCE'}
            </div>
        </div>
    );
};
